export const colors: any = {
    applied: 'linkedin.500',
    'not applied': 'teal.500',
    closed: 'red.500',
    assessment: 'purple.500',
    rejected: 'orange.500',
    interview: 'green.500',
};

export  const colors_hover: any = {
    applied: 'linkedin.600',
    'not applied': 'teal.600',
    closed: 'red.600',
    assessment: 'purple.600',
    rejected: 'orange.600',
    interview: 'green.600',
};
